import React from 'react'
import { apiConstants } from '../../constants/apiConstants'

function MobileHeader() {
  return (
    <div className="vx_globalNav-main_mobile">
      <div className="vx_globalNav-headerSection_trigger">
        <div className="vx_globalNav-toggleTrigger-container">
          <label
            className="vx_globalNav-toggleTrigger_animated"
            htmlFor="toggleNavigation"
          >
            <span />
            <div className="vx_globalNav-toggleTrigger_animated_open">Menu</div>
            <div className="vx_globalNav-toggleTrigger_animated_close">
              Close
            </div>
          </label>
        </div>
      </div>
      <div className="vx_globalNav-headerSection_logo">
        <a
          href={`${apiConstants.URLPrefix}`}
          id="header-ppLogo_mobile"
          className="vx_globalNav-brand_mobile header__logo"
        >
          <div className="ppvx_text--md header__logo-text">DropZone</div>
          <span className="vx_a11yText">Home</span>
        </a>
      </div>
      <ul className="vx_globalNav-headerSection_actions hide">
        <li className="vx_globalNav-actionItem_mobileglobalNav_notificationItem vx_globalNav-notificationItem_mobile">
          <a
            className="vx_globalNav-svgIcon vx_globalNav-link_notifications notifications_mobile vx_isCritical js_notificationDesktopBtn cw_notifications-mobile-trigger"
            id="header-openNotifications"
            role="button"
            title="Notifications"
            data-popover-autodisplay="false"
            data-modal-id="notifications-mobile"
          >
            <span className="ppvx_icon ppvx_icon--size_lg ppvx_icon-notification header__icon--color" />
            <span className="vx_notificationCount js_notificationCount">1</span>
            <span className="vx_a11yText">Notifications</span>
          </a>
        </li>
      </ul>
      <div className="vx_modal-flow" id="notifications-mobile">
        <div className="vx_modal-wrapper cw_notifications-modal-wrapper">
          <div className="vx_modal-content cw_notifications-mobile-content">
            <div
              id="notifications-mobile-popover"
              className="cw_notifications-mobile-container"
              tabIndex="0"
            >
              <header className="vx_modal-header cw_notifications-mobile-content-header">
                <span
                  className="vx_modal-dismiss_trigger"
                  data-modal-id="notifications-mobile"
                >
                  <svg
                    className="close-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 97.998 120"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    data-id="cw_notifications-mobile-dismiss"
                  >
                    <path
                      stroke="#2C2E2F"
                      fill="#2C2E2F"
                      d="m82.91 99.121q2.8e-14 0.87891-0.53711 1.416-0.53711 0.53711-1.416 0.53711-0.87891 0-1.4648-0.58594l-30.469-30.469c-7.6538 7.6416-22.961 22.925-30.615 30.566q-0.53711 0.58594-1.416 0.58594t-1.416-0.58594q-1.416-1.416 0-2.7832c10.173-10.205 22.888-22.961 30.518-30.615-7.6294-7.6172-22.888-22.852-30.518-30.469q-1.416-1.5137 0-2.8809 1.416-1.3672 2.9297-0.048829c10.173 10.205 22.888 22.961 30.518 30.615 7.6416-7.6538 22.925-22.961 30.566-30.615q0.48828-0.58594 1.3672-0.58594t1.4648 0.58594q1.416 1.416 0 2.832c-10.205 10.189-22.961 22.925-30.615 30.566 7.6294 7.6294 22.888 22.888 30.518 30.518q0.58594 0.53711 0.58594 1.416z"
                      strokeWidth="0px"
                    />
                  </svg>
                  <span className="vx_a11yText">Close</span>
                </span>
                <span className="ppvx_icon ppvx_icon--size_lg ppvx_icon-notification header__icon--color" />
              </header>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileHeader
